import React from 'react'
import classNames from 'classnames'

import { ImgSanity } from '@slite/components'

import { WebsiteText } from '../../../components/WebsiteText'

type ArgsDuoWithFrameProps = {
  data: {
    label: React.ReactNode
    title: React.ReactNode
    description: React.ReactNode
    imageSrc: string
  }[]
  className?: string
}

export const ArgsDuoWithFrame = ({
  data,
  className,
}: ArgsDuoWithFrameProps) => {
  return (
    <div
      className={classNames(
        'grid-12 grid-column-gap-24 grid-row-gap-24-small',
        className
      )}
    >
      {data.map((item, index) => (
        <div
          key={index}
          className="grid-span-6 padding-top-40 radius-larger flexbox flexbox-column overflow-hidden grid-span-12-small"
          style={{ background: '#fdf9f4' }}
        >
          <div className="padding-horizontal-32 flexbox-grow">
            <WebsiteText
              variant="smallUppercase"
              className="shade-30 margin-bottom-12"
            >
              {item.label}
            </WebsiteText>
            <h4 className="font-family-title font-size-4 font-weight-medium margin-bottom-4">
              {item.title}
            </h4>
            <WebsiteText variant="body" className="shade-10 margin-bottom-32">
              {item.description}
            </WebsiteText>
          </div>
          <ImgSanity alt="" src={item.imageSrc} className="display-block" />
        </div>
      ))}
    </div>
  )
}
